import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import bg1 from "../Assets/Coursedetails/aiml1.png";
import bg2 from "../Assets/Coursedetails/cse1.png";
import bg3 from "../Assets/Coursedetails/ece1.png";
import bg4 from "../Assets/Coursedetails/civils2.png";
import bg5 from "../Assets/Coursedetails/eee1.png";
import bg6 from "../Assets/Coursedetails/mech1.png";
import bg7 from "../Assets/Coursedetails/cloud1.png";

import hod from "../Assets/courses/chairman.png";

// import Fac1 from "../Assets/Coursedetails/AIML0000.png";
// import Fac2 from "../Assets/Coursedetails/CSE0000.png";
// import Fac3 from "../Assets/Coursedetails/ECE0000.png";
// import Fac4 from "../Assets/Coursedetails/Civils0000.png";
// import Fac5 from "../Assets/Coursedetails/EEE0000.png";
// import Fac6 from "../Assets/Coursedetails/MECH0000.png";
// import Fac7 from "../Assets/Coursedetails/Cloud0000.png";

import Fac1 from "../Assets/Coursedetails/anilprasad.png";
import Fac2 from "../Assets/Coursedetails/CSE0001.png";
import Fac3 from "../Assets/Coursedetails/ECE0001.png";
import Fac4 from "../Assets/Coursedetails/Civils0001.png";
import Fac5 from "../Assets/Coursedetails/EEE0001.png";
import Fac6 from "../Assets/Coursedetails/MECH0001.png";
import Fac7 from "../Assets/Coursedetails/Cloud0001.png";

import mb1 from "../Assets/Coursedetails/aiml01.png";
import mb2 from "../Assets/Coursedetails/cse01.png";
import mb3 from "../Assets/Coursedetails/ece01.png";
import mb4 from "../Assets/Coursedetails/civils01.png";
import mb5 from "../Assets/Coursedetails/eee01.png";
import mb6 from "../Assets/Coursedetails/mech02.png";
import mb7 from "../Assets/Coursedetails/cloud01.png";

import Paiml from "../Assets/Packages/aiml.png";
import Pcivil from "../Assets/Packages/civil.png";
import Pcse from "../Assets/Packages/computer.png";
import Peee from "../Assets/Packages/EEE.png";
import PECE from "../Assets/Packages/ECE.png";
import Pmech from "../Assets/Packages/Mechanical.png";
import PCloud from "../Assets/Packages/cloud.png";

import DAIML from "../Assets/Dept/aimll.png";
import DCivil from "../Assets/Dept/civil.png";
import DECE from "../Assets/Dept/ECE.png";
import Deee from "../Assets/Dept/EEE.png";
import Dcloud from "../Assets/Dept/cloud.png";
import DCME from "../Assets/Dept/cme.png";
import DMech from "../Assets/Dept/mech.png";

const courses = [
  {
    id: 1,
    title: "ARTIFICIAL INTELLIGENCE & MACHINE LEARNING (DAIM)",
    subtitle: "Artificial Intelligence",
    heading1: "About Our AI & ML Department",
    heading2: "Why Choose us for AI & ML Education?",
    heading3: "Career Opportunities after Graduation",
    description:
      "Sri Jyothi Polytechnic established the Artificial Intelligence and Machine Learning (AI&ML) department in 2021 with an initial capacity of 66 seats. Due to the increasing demand for AI&ML professionals, the seat capacity was doubled to 132 in 2022. This department is dedicated to providing students with a comprehensive education in AI and ML, combining theoretical foundations with hands-on practical experience to solve real-world problems. The department focuses on training future technologists to excel in data-driven decision-making, algorithm development, and innovation in artificial intelligence. With the rapidly growing demand for AI technologies across industries, our department equips students with the skills needed to thrive in this competitive landscape.",
    buttonText: "Read More",
    text1:
      "Expert Faculty: Educators with extensive experience in AI and ML research and industry projects guide students in their learning journey.",
    text2:
      "Internships and Placements: Partnerships with leading technology firms ensure that students have excellent placement opportunities and real-world exposure.",
    text3:
      "Skill Development: Comprehensive training in Python programming, machine learning algorithms, data visualization, and AI frameworks.",
    txt: "Our graduates are well-prepared to take up roles such as:",
    img1: bg1,
    img2: Fac1,
    img3: mb1,                                          
    civil1: "AI & ML Engineer",
    civil2: "AI Researcher",
    civil3: "Robotics Engineer",
    civil4: "Business Intelligence Developer",
    civil5:'Data scientist',
    civil6:'Data software developer specializing in AI',
    link: "/course-details/1",
    KeySkills:
      "Artificial Intelligence and Machine Learning include proficiency in programming (Python, R), knowledge of algorithms, data processing, and expertise in frameworks like TensorFlow and Scikit-learn.AI & ML specialists work on automation, predictive analysis, and intelligent data processing. They develop algorithms that improve decision-making and enhance business operations. Industries such as healthcare, finance, and e-commerce actively recruit AI professionals. Graduates find roles in chatbot development, machine vision, and deep learning applications. As AI adoption increases, demand for skilled professionals in neural networks and automation grows. AI engineers also contribute to robotics and advanced data analytics.",
    titledata1:
      "Artificial Intelligence focuses on creating systems that simulate human intelligence, while Machine Learning enables computers to learn from data and improve their performance over time.",
    package1: Paiml,
    Dept1:
      "The Artificial Intelligence and Machine Learning (AI&ML) staff at Sri Jyothi Polytechnic play a crucial role in equipping students with industry-relevant skills in artificial intelligence, data science, and automation. They design and deliver practical, hands-on training programs, ensuring students understand core AI&ML concepts, algorithms, and real-world applications. By integrating innovative teaching methods and staying updated with the latest advancements, they prepare students for careers in AI-driven industries, fostering problem-solving abilities and technological expertise.This branch focuses on developing intelligent systems using data science, deep learning, and automation. Students learn programming, AI algorithms, and neural networks to build smart applications. It plays a crucial role in robotics, healthcare, finance, and various industries. The demand for AIML professionals is rapidly increasing in the tech-driven world.",
      DeptImg: DAIML,
  },
  {
    id: 2,
    title: "COMPUTER ENGINEERING (DCME)",
    subtitle: "Computer Engineering",

    heading1: "About Our CME Department",
    heading2: "Why Choose us for CME Education?",
    heading3: "Career Opportunities after Graduation",
    description:
      "The Computer Engineering (CME) department at Sri Jyothi Polytechnic has been a cornerstone of technical education since its inception. Our mission is to provide students with a comprehensive understanding of computer science concepts, software development, and emerging technologies.The department offers a dynamic and flexible curriculum designed to meet the needs of the ever-changing tech industry. Students gain expertise in various areas, including software development, data analytics, cybersecurity and Internet of Things (IoT). The curriculum blends theoretical foundations with extensive practical sessions to ensure a well-rounded learning experience.",
    buttonText: "Read More",
    text1:
      "State-of-the-Art Labs: Well-equipped labs for software development, network simulation and project-based learning.",
    text2:
      "Experienced Faculty: Experts with academic and industry backgrounds mentor students to achieve their career aspirations.",
    text3:
      "Internship & Placement Support: The department has strong ties with top IT firms, offering excellent placement opportunities.",
    txt: "Graduates can pursue a variety of roles, including:",
    img1: bg2,
    img2: Fac2,
    img3: mb2,
    civil1: "Software Developer",
    civil2: "System Architect",
    civil3: "Data Analyst",
    civil4: "Network Engineer",
    link: "/course-details/2",
    KeySkills:
      "Computer Engineering include proficiency in programming, hardware design, circuit analysis, system architecture, and understanding of software development and networking.CME graduates specialize in software development, networking, and cybersecurity. They work with IT firms, hardware manufacturers, and system integrators. Their skills in coding, troubleshooting, and database management make them valuable in software companies. Career opportunities exist in areas like cloud computing, IT support, and cybersecurity analysis. The demand for computer engineers is increasing due to digital transformation across industries. With expertise in programming languages and AI, they play a key role in software innovation.",
    titledata1:
      "Computer Engineering combines principles of electrical engineering and computer science to design, develop, and optimize hardware and software systems.",
    package1: Pcse,
    Dept1:
      "The Computer Engineering (CME) staff train students in software development, cybersecurity, and hardware integration, preparing them for roles in IT infrastructure and computing solutions.CME integrates computer science with modern hardware and software applications. It covers programming, cybersecurity, AI, and networking technologies. Students work on advanced computing solutions, cloud-based systems, and smart devices. This field is crucial for the development of intelligent and efficient computing systems.",
    DeptImg: DCME,
  },
  {
    id: 3,
    title: "ELECTRONICS & COMMUNICATION ENGINEERING (DECE)",
    subtitle: "Electronics & Communication",
    heading1: "About Our ECE Department",
    heading2: "Why Choose us for ECE Education?",
    heading3: "Career Opportunities after Graduation",
    description:
      "Sri Jyothi Polytechnic Electronics and Communication Engineering (ECE) department is committed to providing students with a strong foundation in electronic circuits, communication systems and digital technologies.The department aims to create competent engineers capable of designing, developing and testing communication systems, embedded devices and electronic equipment for various applications. Our curriculum emphasizes innovation, problem-solving and practical knowledge to prepare students for the evolving technological landscape.",
    buttonText: "Read More",
    text1:
      "Advanced Labs: State-of-the-art facilities for hands-on experiments and prototyping.",
    text2:
      "Industry Collaboration: Opportunities to work on live projects and research collaborations with top tech firms.",
    text3:
      "Mentorship: Experienced faculty provide individualized attention and career guidance.",
    txt: "Graduates can work in roles such as:",
    img1: bg3,
    img2: Fac3,
    img3: mb3,
    civil1: "Communication Engineer",
    civil2: "Embedded System Developer",
    civil3: "VLSI Designer",
    civil4: "Research Engineer",
    link: "/course-details/3",
    KeySkills:
      " Electronics and Communication Engineering include circuit design, communication systems, signal processing, programming, and proficiency in tools like MATLAB and embedded systems.ECE professionals work in telecommunications, embedded systems, and consumer electronics. They contribute to industries that focus on circuit design, mobile networks, and IoT devices. With the rapid expansion of 5G and communication networks, job opportunities are increasing. Graduates work with companies specializing in microelectronics, semiconductor technology, and wireless communication. Automation, robotics, and AI integration in electronic devices create new career pathways. Their expertise in signal processing and data transmission remains essential in advancing digital communication technologies.",
    titledata1:
      "Electronics and Communication Engineering focuses on the design, development, and maintenance of electronic systems and communication networks, integrating both hardware and software solutions.",
    package1: PECE,
    Dept1:
      "ECE professionals work in telecommunications, embedded systems, and consumer electronics. They contribute to industries that focus on circuit design, mobile networks, and IoT devices. With the rapid expansion of 5G and communication networks, job opportunities are increasing. Graduates work with companies specializing in microelectronics, semiconductor technology, and wireless communication. Automation, robotics, and AI integration in electronic devices create new career pathways. Their expertise in signal processing and data transmission remains essential in advancing digital communication technologies.",
    DeptImg: DECE,
  },
  {
    id: 4,
    title: "CIVIL ENGINEERING",
    subtitle: "Civil Engineering",
    heading1: "About Our Civil Engineering Department",
    heading2: "Why Choose us for Civil Engineering Education?",
    heading3: "Career Opportunities after Graduation",
    description:
      "The Civil Engineering department at Sri Jyothi Polytechnic is dedicated to building the nation by creating innovative and sustainable infrastructure solutions.The department focuses on teaching the principles of structural design, environmental management and material studies. Students gain practical knowledge through field visits, lab sessions and exposure to real-world projects.",
    buttonText: "Read More",
    text1:
      "Comprehensive Curriculum: Courses cover surveying, structural analysis, environmental studies and project management.",
    text2:
      "Hands-on Learning: Industry collaborations and practical sessions help bridge the gap between classroom learning and real-world applications.",
    text3:
      "Expert Faculty: Professors with vast industry experience guide students in their academic and professional journeys.",
    txt: "Graduates can pursue roles such as:",
    img1: bg4,
    img2: Fac4,
    img3: mb4,
    civil1: "Structural Engineer",
    civil2: "Project Manager",
    civil3: "Urban Planner",
    civil4: "Civil Consultant",
    link: "/course-details/4",
    KeySkills:
      "Civil Engineering include expertise in structural design, project management, construction materials, surveying, and proficiency in software like AutoCAD and SAP2000.Civil Engineering diploma holders play a crucial role in infrastructure development, construction, and urban planning. They work in sectors like real estate, highways, and structural engineering. Graduates find opportunities with top construction firms, government projects, and private developers. Their expertise in structural design, surveying, and site supervision is highly valued. They contribute to the development of bridges, roads, and large-scale construction projects. Sustainable engineering practices and environmental concerns are becoming key aspects of this field.",
    titledata1:
      "Civil Engineering involves the design, construction, and maintenance of infrastructure projects like roads, bridges, and buildings, focusing on safety, functionality, and sustainability.",
    package1: Pcivil,
    Dept1:
      "The Civil Engineering department staff emphasize structural design, construction management, and sustainable engineering practices, equipping students with the skills to work on infrastructure development and urban planning.Civil engineering deals with designing, constructing, and maintaining infrastructure like roads, bridges, and buildings. It includes structural analysis, geotechnical engineering, and environmental studies. Students gain skills in surveying, construction management, and sustainable urban planning. This field is essential for national development and environmental conservation.",
    DeptImg: DCivil,
  },
  {
    id: 5,
    title: "ELECTRICAL & ELECTRONICS ENGINEERING (DEEE)",
    subtitle: "Electrical & Electronics",
    heading1: "About Our EEE Department",
    heading2: "Why Choose us for EEE Education?",
    heading3: "Career Opportunities after Graduation",
    description:
      "The Electrical and Electronics Engineering (EEE) department at Sri Jyothi Polytechnic provides students with a strong foundation in electrical circuits, electronics and power systems.The department emphasizes practical knowledge and problem-solving skills to prepare students for roles in energy production, automation and electronics design.",
    buttonText: "Read More",
    text1:
      "Diverse Curriculum: Focus on power electronics, renewable energy sources and automation technologies.",
    text2:
      "Advanced Labs: Well-equipped for experiments in high-voltage engineering, embedded systems and robotics.",
    text3:
      "Industry Exposure: Collaboration with industry partners for internships and projects.",
    txt: "Graduates can become:",
    img1: bg5,
    img2: Fac5,
    img3: mb5,
    civil1: "Power System Engineer",
    civil2: "Automation Specialist",
    civil3: "Electrical Consultant",
    civil4: "Electronics Engineer",
    link: "/course-details/5",
    KeySkills:
      "Electrical and Electronics Engineering include expertise in circuit design, power systems, signal processing, control systems, and proficiency with tools like MATLAB and CAD software.EEE diploma graduates contribute significantly to power systems, electrical machinery, and industrial automation. They work in power distribution, control systems, and renewable energy industries. Their expertise is essential in maintaining electrical grids, transformers, and power stations. Career opportunities exist in both private and government sectors, including energy firms and metro rail projects. With the rise of smart grids and green energy solutions, their role is expanding. They also find employment in automation and robotics, where electrical control systems are key components.",
    titledata1:
      "Electrical and Electronics Engineering focuses on the design, development, and maintenance of electrical systems, electronics, and communication devices, integrating power and signal processing technologies",
    package1:  Peee,
    Dept1:
      "The Electrical and Electronics Engineering (EEE) faculty provide in-depth knowledge of power systems, control systems, and renewable energy technologies, preparing students for careers in electrical automation and industrial power management.EEE focuses on electrical power generation, transmission, and distribution along with electronics applications. It covers electric circuits, power systems, renewable energy, and industrial automation. Students learn about motors, transformers, and energy-efficient technologies. The field plays a key role in power plants, smart grids, and electrical industries.",
    DeptImg: Deee,
  },
  {
    id: 6,
    title: "MECHANICAL ENGINEERING",
    subtitle: "Mechanical",
    heading1: "About Our Mechanical Engineering Department",
    heading2: "Why Choose us for Mechanical Engineering Education?",
    heading3: "Career Opportunities after Graduation",
    description:
      "The Mechanical Engineering department at Sri Jyothi Polytechnic aims to nurture innovative thinkers and problem-solvers in the field of mechanical systems.Students learn the principles of design, manufacturing and thermal sciences. The curriculum blends theoretical knowledge with practical applications to prepare students for diverse career paths.",
      buttonText: "Read More",
    text1: "Robust Curriculum: Focus on fluid dynamics, CAD/CAM, and robotics.",
    text2:
      "Hands-on Training: Workshops and practical sessions are integral to the learning process.",
    text3:
      "Industry Interaction: Strong partnerships with industries for project-based learning and research.",
    txt: "Graduates can work as:",
    img1: bg6,
    img2: Fac6,
    img3: mb6,
    civil1: "Mechanical Design Engineers",
    civil2: "Thermal Analysts",
    civil3: "Robotics Experts",
    civil4: "Manufacturing Engineers",
    link: "/course-details/6",
    KeySkills:
      "Mechanical Engineering include proficiency in CAD software, thermodynamics, material science, mechanical design, and knowledge of manufacturing processes and systems analysis.Mechanical Engineering professionals are in demand across manufacturing, automotive, and industrial sectors. They work on designing, analyzing, and maintaining mechanical systems, including engines and industrial machinery. Career opportunities exist in industries like automobile manufacturing, HVAC systems, and robotics. With advancements in automation and CAD/CAM technologies, their skill set is evolving rapidly. Many mechanical engineers also specialize in material science and thermal engineering. The need for sustainable energy solutions has further expanded job prospects in renewable energy sectors.",
    titledata1:
      "Mechanical Engineering involves the design, analysis, and manufacturing of mechanical systems, focusing on mechanics, thermodynamics, and material science to solve engineering problems.",
       package1: Pmech,
    Dept1:
      "The Mechanical Engineering (MEC) faculty specialize in thermodynamics, manufacturing processes, and CAD/CAM technologies, ensuring students develop practical expertise in designing and maintaining mechanical systems.This branch focuses on designing and manufacturing mechanical systems, engines, and machines. It covers thermodynamics, robotics, CAD/CAM, and automotive engineering. Students learn about energy systems, material science, and production techniques. Mechanical engineers contribute to industries like aerospace, automation, and renewable energy.",
       DeptImg: DMech,
  },
  {
    id: 7,
    title: "CLOUD COMPUTING AND BIG DATA (DCCB)",
    subtitle: "Cloud Computing",
    heading1: "About Our Cloud Computing & Big Data Department",
    heading2: "Why Choose us for Cloud Computing & Big Data Education?",
    heading3: "Career Opportunities after Graduation",
    description:
      "The Cloud Computing & Big Data (DCCB) department at Sri Jyothi Polytechnic is designed to prepare students for the next generation of digital innovation.The department offers a specialized curriculum focusing on cloud infrastructure, big data analytics and advanced data management techniques.",
    buttonText: "Read More",
    text1:
      "Specialized Curriculum: Courses on cloud architecture, big data analytics, and machine learning.",
    text2:
      "Advanced Infrastructure: Labs equipped for cloud simulation and analytics projects.",
    text3:
      "Placement Opportunities: Strong ties with tech companies provide excellent job prospects.",
    txt: "Graduates can become:",
    img1: bg7,
    img2: Fac7,
    img3: mb7,
    civil1: "Cloud Architects",
    civil2: "Data Analysts",
    civil3: "Big Data Engineers",
    civil4: "Cloud Consultants",
    link: "/course-details/7",
    titledata1:
      "Cloud Computing provides scalable, on-demand access to computing resources over the internet, while Big Data focuses on analyzing vast amounts of data to extract valuable insights.",
    KeySkills:
      "Cloud Computing requires expertise in cloud platforms (AWS, Azure), containerization, automation, and security, while Big Data involves skills in Hadoop, Spark, programming, and data analysis.Cloud computing professionals manage virtualization, cloud security, and distributed computing systems. They work with major IT firms, cloud service providers, and data centers. Their expertise in handling cloud infrastructure is essential for businesses shifting to digital platforms. Opportunities exist in cloud architecture, DevOps, and IT infrastructure management. Cloud security and data privacy have become key areas of focus in this domain. With the rise of remote work and digital storage needs, cloud computing careers are in high demand.",
    package1: PCloud,
    Dept1:
      "The Cloud Computing faculty focus on virtualization, data security, and cloud infrastructure management, ensuring students are ready for careers in cloud-based IT solutions and enterprise computing.Cloud computing focuses on virtualized storage, networking, and scalable IT solutions. It covers cloud architecture, security, and data management for distributed computing. Students learn about platforms like AWS, Azure, and Google Cloud for enterprise solutions. Cloud professionals are in high demand for ensuring efficient and secure digital transformation.",
      DeptImg: Dcloud,
  },
];

const CourseDetail = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  const { id } = useParams();
  const course = courses.find((course) => course.id === parseInt(id));

  if (!course) {
    return <div>Course not found!</div>;
  }

  return (
    <div className="coursedetails-container mt-0 pt-5 bg-white">
      <h2
        className="text-3xl font-semibold fw-bold mt-0 ml-12 mb-2 text-center mb-5"
        style={{ marginLeft: "3.5%" }}
      >
        {course.title}
      </h2>

      <img src={course.img1} className=" w-100" alt="course banner" />

      <div
        className="flex flex-wrap md:flex-nowrap sm:flex-wrap lg:flex-wrap xl:flex-wrap 2xl:flex-wrap justify-between mr-12 ml-12"
        style={{ marginLeft: "3.5%" }}
      >
        {/* Text Content */}
        <div className="w-full md:w-[60%] text-align-start mt-3 order-2 md:order-1">
          <p className="text-lg font-semibold mb-2">{course.heading1}</p>
          <h6 className="text-md mb-2">{course.description}</h6>
          <p className="text-lg font-semibold mb-2">{course.heading2}</p>
          <ul className="list-disc pl-4">
            <li className="text-md">{course.text1}</li>
            <li className="text-md">{course.text2}</li>
            <li className="text-md mb-2">{course.text3}</li>
          </ul>

          <p className="text-lg font-semibold mb-0">{course.heading3}</p>
          <p className="text-lg mb-2">{course.txt}</p>
          <ul className="list-disc pl-4">
            <li className="text-md">{course.civil1}</li>
            <li className="text-md">{course.civil2}</li>
            <li className="text-md">{course.civil3}</li>
            <li className="text-md">{course.civil4}</li>
            <li className="text-md">{course.civil5}</li>
            <li className="text-md">{course.civil6}</li>
          </ul>
        </div>

        {/* Image Content */}
        <div className="w-full md:w-auto order-1 md:order-2">
          <img src={course.img2} className="img-fluid mt-7 shadow" alt="HOD" />
        </div>
      </div>

      {/* <hr className="border-t-2 border-gray-300 mt-2 mx-12 mb-2" /> */}

      <div className="bg-[#F5F7FA] flex justify-between w-[95%] mx-auto p-3 items-center flex-col md:flex-row mt-5">
        <div className="w-[90%] md:w-[60%]">
          <h1 className="text-lg font-semibold mb-0">{course.subtitle}</h1>
          <h3>{course.titledata1}</h3>
          <div className="mt-5 text-justify">
            <span className="text-lg font-semibold mb-0">Key Skills:</span>{" "}
            <span className="leading-relaxed">{course.KeySkills}</span>
          </div>
        </div>
        <div className="h-[50%] w-[80%] sm:w-80">
          <img src={course.package1} />
        </div>
      </div>

      <div className="bg-[#F5F7FA] flex justify-between w-[95%] mx-auto p-3 items-center flex-col md:flex-row">
        <div className="h-[50%] w-[80%] sm:w-[35%] flex justify-center shadow-lg">
          <img src={course.DeptImg} />
        </div>
        <div className="w-[100%] md:w-[63%]  text-justify">
          <h1 className="leading-relaxed md:w-[70%] mx-auto">{course.Dept1}</h1>
        </div>
      </div>

      <hr className="border-t-2 border-gray-300 mt-2 mx-12" />

      <img
        src={course.img3}
        className="img-fluid w-full mt-[-1.9%]"
        alt="course related image"
      />
    </div>
  );
};

export default CourseDetail;
